export enum ReportDrilldownSortKeys {
  COMPLETION_RATE_ASC = 'completionRate_asc',
  COMPLETION_RATE_DESC = 'completionRate_desc',
  NAME_ASC = 'name_asc',
  NAME_DESC = 'name_desc'
}
